import { Col, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import Form from "../../form-components/from";
import TrademarkContext from "../../../context/trademark/context";
import { useLocation } from "react-router-dom";
import { addSearchToURL, filtersToQueryString, getFiltersFromURL, getKeywordFromURL } from "../../../utils/helpers/url";

interface IProps { }

const TrademarkFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(TrademarkContext);

  const location = useLocation();
  const [initialValues, setInitialValues] = useState<Record<string, any>>({});

  useEffect(() => {
    const filters = getFiltersFromURL();

    const initialValuesObj = {};
    filters.forEach((f) => {
      initialValuesObj[f.name] = f.value;
    });

    setInitialValues(initialValuesObj);
  }, [location.search]);
  return (
    <Form
      formId="trademark-filter"
      defaultValues={initialValues}
      onSubmit={(data) => {
        const keyword = getKeywordFromURL();
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: keyword,
          filters: [
            data?.isSpecial
              ? {
                name: "isSpecial",
                value: data.isSpecial,
                operation: "eq",
              }
              : undefined,
            data?.exportPurchaseInvoiceReport
              ? {
                name: "exportPurchaseInvoiceReport",
                value: data.exportPurchaseInvoiceReport,
                operation: "eq",
              }
              : undefined,
          ].filter((f) => f),
        };
        const queryString = filtersToQueryString(filter.filters);
        window.history.replaceState(null, "", `?${queryString}`);
        addSearchToURL(keyword);
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="isSpecial"
            label={`${t("trademark_type")}`}
            width="large"
            input={{
              type: "select",
              options: [1, 2].map((cat, index) => {
                return {
                  label: index == 0 ? t("special") : t("not_special"),
                  value: index == 0 ? 1 : "0",
                };
              }),
            }}
          />
        </Col>
      </Row>
      <Row justify={"start"} gutter={[10, 0]}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
            <FieldBuilder
              name="exportPurchaseInvoiceReport"
              label={`${t("export_purchase_invoice_report")}`}
              width="large"
              input={{
                type: "select",
                options: [1, 2].map((cat, index) => {
                  return {
                    label: index == 0 ? t("yes") : t("no"),
                    value: index == 0 ? 1 : "0",
                  };
                }),
              }}
            />
          </Col>
        </Row>
    </Form>
  );
};

export default TrademarkFilter;
